module.exports = __webpack_public_path__ + "fonts/Brandon_Grotesque_Medium_cyrillic.2d62968f.ttf";